import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "./styles/design-system.css";
import "./styles/app.css";
import "./styles/leads.css";
import "./styles/public-atlas.css";

import { bootstrapApplication } from "./bootstrap";

const start = (): void => {
  void bootstrapApplication(document).catch((error: unknown) => {
    console.error("WISP Planner page bootstrap failed.", error);
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start, { once: true });
} else {
  start();
}
